<template>
    <div class="profile-settings-email">
        <span class="profile-settings-email__heading">Email ayarların</span>
        <span class="profile-settings-email__description">Eski mailine gelecek onay kodu ile hesabını yeni mailine bağlayabilirsin.</span>
        <span class="profile-settings-email__art-separator"></span>
        <Preloader
            v-if="show.preloader"
            preloaderText="Yükleniyor..." />
        <div class="profile-settings-email-change" v-if="show.emailChange">
            <span class="profile-settings-email-change__heading">Email Değişikliği</span>
            <div class="profile-settings-email-change-wr-input-label">
                <label class="profile-settings-email-change__label">Eski email</label>
                <div class="profile-settings-email-change-wr-input">
                    <input class="profile-settings-email-change__inp-email" type="text" :value="this.$store.state.userSession.email" disabled>
                    <svg class="profile-settings-email-change__inp-email-icon" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_64_279)"><path class="disabled-path" fill-rule="evenodd" clip-rule="evenodd" d="M.381.818C.733.328 1.305 0 1.96 0h10.08c.655 0 1.227.328 1.579.818.24.334.381.747.381 1.189v7.186c0 1.084-.854 2.007-1.96 2.007H1.96C.854 11.2 0 10.277 0 9.193V2.007c0-.443.14-.855.381-1.19zm1.672.582l4.429 4.875a.7.7 0 001.036 0l4.43-4.875H2.052zM12.6 2.763L8.554 7.217a2.1 2.1 0 01-3.108 0L1.4 2.763v6.43c0 .36.275.607.56.607h10.08c.286 0 .56-.247.56-.607v-6.43z" fill="#919191"/></g><defs><clipPath id="clip0_64_279"><path fill="#fff" d="M0 0h14v11.2H0z"/></clipPath></defs></svg>
                </div>
            </div>
            <div class="profile-settings-email-change-wr-input-label">
                <label class="profile-settings-email-change__label">Yeni email</label>
                <div class="profile-settings-email-change-wr-input">
                    <input class="profile-settings-email-change__inp-email" type="text" @input="inputEmailNew" :value="$store.state.input.profile.emailNew" @keyup.enter="$store.state.envDev == true ? requestEmailChange() : requestEmailChangeApi()">
                    <svg class="profile-settings-email-change__inp-email-icon" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_64_279)"><path class="profile-settings-email__second-path" fill-rule="evenodd" clip-rule="evenodd" d="M.381.818C.733.328 1.305 0 1.96 0h10.08c.655 0 1.227.328 1.579.818.24.334.381.747.381 1.189v7.186c0 1.084-.854 2.007-1.96 2.007H1.96C.854 11.2 0 10.277 0 9.193V2.007c0-.443.14-.855.381-1.19zm1.672.582l4.429 4.875a.7.7 0 001.036 0l4.43-4.875H2.052zM12.6 2.763L8.554 7.217a2.1 2.1 0 01-3.108 0L1.4 2.763v6.43c0 .36.275.607.56.607h10.08c.286 0 .56-.247.56-.607v-6.43z" fill="#919191"/></g><defs><clipPath id="clip0_64_279"><path fill="#fff" d="M0 0h14v11.2H0z"/></clipPath></defs></svg>
                </div>
            </div>
            <button class="profile-settings-email-change-btn-confirm" @click="$store.state.envDev == true ? requestEmailChange() : requestEmailChangeApi()">
                <span class="profile-settings-email-change-btn-confirm__text">Onayla</span>
            </button>
        </div>
        <div class="profile-settings-email-confirm" v-if="show.emailConfirm">
            <span class="profile-settings-email-confirm__heading">Email Değişikliği</span>
            <span class="profile-settings-email-confirm__description">{{ this.$store.state.userSession.email }} adresine gelen onay kodunu girerek mail değişikliğini onaylayabilirsin.</span>
            <span class="profile-settings-email-confirm__time">Kalan Süre: {{ expireTime }}</span>
            <div class="profile-settings-email-confirm-form">
                <label class="profile-settings-email-confirm-form__label">Onay Kodu</label>
                <input class="profile-settings-email-confirm-form__inp-text"
                    @input="inputEmailChangeCode">
                <input class="profile-settings-email-confirm-form__inp-text"
                    @input="inputEmailChangeCode">
                <input class="profile-settings-email-confirm-form__inp-text"
                    @input="inputEmailChangeCode">
                <input class="profile-settings-email-confirm-form__inp-text"
                    @input="inputEmailChangeCode">
                <button
                    class="profile-settings-email-confirm-form-btn-confirm"
                    @click="$store.state.envDev == true ? confirmEmailChangeCode() : confirmEmailChangeCodeApi()">
                    <span class="profile-settings-email-confirm-form-btn-confirm__text">Onayla</span>
                </button>
            </div>
        </div>
        <div
            class="profile-settings-email-success"
            v-if="show.emailSuccess">
                <span class="profile-settings-email-success__art-success"></span>
                <span class="profile-settings-email-success__heading">Başarılı</span>
                <span class="profile-settings-email-success__text">Emailin başarıyla değiştirildi.</span>
        </div>
    </div>
</template>
<script>
    // Library imports.
    import validator from 'validator';

    // Component imports.
    import Preloader from '@/components/Preloader.vue';

    export default {
        components: {
            Preloader,
        },

        data(){
            return {
                show: {
                    preloader: false,
                    emailChange: true,
                    emailConfirm: false,
                    emailSuccess: false,
                },
                intervals: {
                    confirmationTimer: null
                },
                expireTime: '',
            };
        },

        methods: {
            inputEmailNew(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'profile',
                    dataLabel: 'emailNew',
                    data: event.target.value,
                });
            },

            requestEmailChange(){
                if(this.$store.state.input.profile.emailNew.length < 1){
                    this.$foneturkError({
                        text: 'Yeni email boş olamaz.'
                    });
                    return;
                }
                
                if(validator.isEmail(this.$store.state.input.profile.emailNew) == false){
                    this.$foneturkError({
                        text: 'Girdiğin email geçersiz.'
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.emailChange = false;

                fetch(this.$store.state.jsonServer.emailChangeRequest)
                .then(response => response.json())
                .then(emailChangeRequestData => {
                    this.show.preloader = false;
                    if(emailChangeRequestData.result){
                        this.show.emailConfirm = true;
                        this.$store.commit('setResponse', {
                            categoryLabel: 'profile',
                            dataLabel: 'emailChangeRequestData',
                            data: emailChangeRequestData,
                        });
                        this.startConfirmationTimer();
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti',
                        });
                        this.show.emailChange = true;
                    }
                })
            },

            requestEmailChangeApi(){
                if(this.$store.state.input.profile.emailNew.length < 1){
                    this.$foneturkError({
                        text: 'Yeni email boş olamaz.'
                    });
                    return;
                }
                
                if(validator.isEmail(this.$store.state.input.profile.emailNew) == false){
                    this.$foneturkError({
                        text: 'Girdiğin email geçersiz.'
                    });
                    return;
                }

                if(this.$store.state.input.profile.emailNew == this.$store.state.userSession.email){
                    this.$foneturkError({
                        text: 'Yeni mailin eskisiyle aynı olamaz.'
                    });
                    return;
                };

                this.show.preloader = true;
                this.show.emailChange = false;

                let emailChangeRequestOptions = {
                    emailOld: this.$store.state.userSession.email,
                    emailNew: this.$store.state.input.profile.emailNew,
                };

                fetch(this.$store.state.api.requestEmailChange, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        "Content-Type": 'application/x-www-form-urlencoded'
                    },
                    body: `emailChangeRequestOptions=${JSON.stringify(emailChangeRequestOptions)}`
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(emailChangeRequestData => {
                    this.show.emailConfirm = true;
                    this.$store.commit('setResponse', {
                        categoryLabel: 'profile',
                        dataLabel: 'emailChangeRequestData',
                        data: emailChangeRequestData
                    });
                    this.startConfirmationTimer();
                })
                .catch(err => {
                    this.show.emailChange = true;
                    if(err.code == 'REQUEST_EMAIL_CHANGE_MODEL/RUN::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: 'Önce giriş yapmalısın.',
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        })
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.'
                        });
                    }
                })
            },

            startConfirmationTimer(){
                let expireTime;
                if(this.$store.state.envDev){
                    expireTime = Math.floor(Date.now() / 1000) + 300;
                }
                else{
                    expireTime = this.$store.state.response.profile.emailChangeRequestData.expireTime;
                }

                this.intervals.confirmationTimer = setInterval(() => {
                    let currentTime = Math.floor(Date.now() / 1000);
                    let timediff = expireTime - currentTime;
                    let minsdiff = Math.floor(timediff / 60);
                    let secsdiff = timediff % 60;

                    if(minsdiff < 10){
                        minsdiff = '0' + minsdiff;
                    }
                    if(secsdiff < 10){
                        secsdiff = '0' + secsdiff;
                    }
                    this.expireTime = `${minsdiff}:${secsdiff}`;

                    if(timediff <= 0){
                        clearInterval(this.intervals.confirmationTimer);
                        this.expireTime = '00:00';
                        return;
                    }
                }, 250);
            },

            inputEmailChangeCode(event){
                event.currentTarget.value = event.data;

                document.querySelector('.profile-settings-email-confirm').classList.remove('profile-settings-email-confirm--error');

                if(event.currentTarget.nextSibling.classList.contains('profile-settings-email-confirm-form__inp-text')){
                    event.currentTarget.nextSibling.focus();
                }

                let concatenatedValue = "";
                document.querySelectorAll('.profile-settings-email-confirm-form__inp-text').forEach((el, idx) => {
                    concatenatedValue = concatenatedValue + el.value;
                });
                this.$store.commit('setInput', {
                    categoryLabel: 'profile',
                    dataLabel: 'emailChangeCode',
                    data: concatenatedValue,
                });
            },

            confirmEmailChangeCode(){
                if(this.$store.state.input.profile.emailChangeCode.length < 4){
                    this.$foneturkError({
                        text: 'Onay kodu 4 karakterden oluşmalıdır.',
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.emailConfirm = false;

                fetch(this.$store.state.jsonServer.emailConfirmCode)
                .then(response => response.json())
                .then(emailConfirmationData => {
                    this.show.preloader = false;
                    if(emailConfirmationData.result){
                        this.show.emailSuccess = true;
                        clearInterval(this.intervals.confirmationTimer);
                        this.expireTime = '';
                    }
                    else{
                        this.show.emailConfirm = true;
                        this.$nextTick(() => {
                            document.querySelectorAll('.profile-settings-email-confirm-form__inp-text').forEach((el, idx) => {
                                el.value = this.$store.state.input.profile.emailChangeCode[idx];
                            });
                            document.querySelector('.profile-settings-email-confirm').classList.add('profile-settings-email-confirm--error');
                        })
                        this.$foneturkError({
                            text: 'Bir şeyler yanlış gitti.',
                        });
                    }
                });
            },

            confirmEmailChangeCodeApi(){
                if(this.$store.state.input.profile.emailChangeCode.length < 4){
                    this.$foneturkError({
                        text: 'Onay kodu 4 karakterden oluşmalıdır.',
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.emailConfirm = false;

                let emailChangeConfirmationOptions = {
                    confirmationCode: this.$store.state.input.profile.emailChangeCode
                };

                fetch(this.$store.state.api.confirmEmailChange, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        "Content-Type": 'application/x-www-form-urlencoded'
                    },
                    body: `emailChangeConfirmationOptions=${JSON.stringify(emailChangeConfirmationOptions)}`
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(emailChangeConfirmationData => {
                    this.show.emailSuccess = true;

                    let userSession = this.$store.state.userSession;
                    userSession.email = this.$store.state.input.profile.emailNew;
                    
                    this.$store.commit('setUserSession', userSession);
                    this.$store.commit('setInput', {
                        categoryLabel: 'profile',
                        dataLabel: 'emailNew',
                        data: '',
                    });
                })
                .catch(err => {
                    this.show.emailConfirm = true;
                    this.$nextTick(() => {
                        document.querySelectorAll('.profile-settings-email-confirm-form__inp-text').forEach((el, idx) => {
                            el.value = this.$store.state.input.profile.emailChangeCode[idx];
                        });
                        document.querySelector('.profile-settings-email-confirm').classList.add('profile-settings-email-confirm--error');
                    });
                    if(err.code == 'CONFIRM_EMAIL_CHANGE_MODEL/RUN::EMAIL_CHANGE_REQUEST_EXPIRED'){
                        this.$foneturkError({
                            text: 'Kodu girme süren doldu, yeni bir istek yap.'
                        });
                        return;
                    }
                    if(err.code == 'CONFIRM_EMAIL_CHANGE_MODEL/RUN::CONFIRMATION_CODE_MISMATCH'){
                        this.$foneturkError({
                            text: 'Girdiğin kod yanlış.'
                        });
                        return;
                    }
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                })
            }
        }
    };
</script>
<style scoped src="@/css/components/profile-settings-email.css"></style>